import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/dates/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_TIMESTAMP = NAMESPACE + 'SET_TIMESTAMP'

const defaultCardState = {
  ids: [],
  byId: {},
  isLoading: false,
  isLoaded: false
}

const initialState = {}

const itemDefaults = {
  name: ''
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultCardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    case ADD:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          ids: addUniqueValueToArray({
            array: state[action.payload.cardId].ids,
            value: action.payload.date.id,
            index: action.payload.index
          }),
          byId: {
            ...state[action.payload.cardId].byId,
            [action.payload.date.id]: {
              ...itemDefaults,
              ...state[action.payload.cardId].byId[action.payload.date.id],
              ...action.payload.date
            }
          }
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.cardId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          ids: [ ...state[action.payload.cardId].ids ],
          byId: { ...state[action.payload.cardId].byId },
        }
      }

      action.payload.array.forEach(date => {
        newState[action.payload.cardId].ids = addUniqueValueToArray({
          array: newState[action.payload.cardId].ids,
          value: date.id,
          index: date.index
        })
        newState[action.payload.cardId].byId[date.id] = {
          ...itemDefaults,
          ...newState[action.payload.cardId].byId[date.id],
          ...date
        }
      })

      return newState
    }
    case REMOVE: {
      if (!state[action.payload.cardId] || !state[action.payload.cardId].byId[action.payload.dateId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          ids: [ ...state[action.payload.cardId].ids.filter(id => id !== action.payload.dateId) ],
          byId: { ...state[action.payload.cardId].byId }
        }
      }

      delete newState[action.payload.cardId].byId[action.payload.dateId]

      return newState
    }
    case SET_NAME:
      return (state[action.payload.cardId] && state[action.payload.cardId].byId[action.payload.dateId]) ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          byId: {
            ...state[action.payload.cardId].byId,
            [action.payload.dateId]: {
              ...state[action.payload.cardId].byId[action.payload.dateId],
              name: action.payload.name
            }
          }
        }
      } : state
    case SET_TIMESTAMP:
      return (state[action.payload.cardId] && state[action.payload.cardId].byId[action.payload.dateId]) ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          byId: {
            ...state[action.payload.cardId].byId,
            [action.payload.dateId]: {
              ...state[action.payload.cardId].byId[action.payload.dateId],
              timestamp: action.payload.timestamp
            }
          }
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ cardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      cardId,
      isLoading,
      isLoaded
    }
  }
}

export function add ({ cardId, date }) {
  return {
    type: ADD,
    payload: {
      cardId,
      date
    }
  }
}

export function addArray ({ cardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      cardId,
      array
    }
  }
}

export function remove ({ cardId, dateId }) {
  return {
    type: REMOVE,
    payload: {
      cardId,
      dateId
    }
  }
}

export function setName ({ cardId, dateId, name }) {
  return {
    type: SET_NAME,
    payload: {
      cardId,
      dateId,
      name
    }
  }
}

export function setTimestamp ({ cardId, dateId, timestamp }) {
  return {
    type: SET_TIMESTAMP,
    payload: {
      cardId,
      dateId,
      timestamp
    }
  }
}
